import CloseButton from "components/elements/Button/CloseButton";
import { IngressListItemModel } from "./lib/IngressListItemModel";
import MessageBanner, {
  MessageType,
} from "components/elements/MessageBanner/MessageBanner";
interface IngressErrorPanelProps {
  readonly item: IngressListItemModel;
  readonly onBack: () => void;
}

export default function IngressErrorPanel({
  item,
  onBack,
}: IngressErrorPanelProps) {
  const openSupportForm = () => {
    window.open(process.env.NEXT_PUBLIC_SUPPORT_FORM_URL);
  };

  return (
    <div className="relative flex h-full flex-col justify-center gap-y-4 overflow-scroll rounded-lg border border-neutral-200 px-4">
      <CloseButton className="absolute right-2 top-2" onClick={onBack} />
      <div className="mx-auto h-auto">
        <MessageBanner messageType={MessageType.Error} colourWidth="md">
          <span className="text-sm">Unable to Import this file</span>
        </MessageBanner>
      </div>

      <div className="mx-auto flex space-x-2 rounded-md bg-neutral-100 p-3 text-center">
        <p className="whitespace-pre-wrap text-sm text-secondary">
          {item.message || "No error message available"}
        </p>
      </div>
      <div className="mx-auto flex items-center justify-center p-3">
        <p className="text-center text-sm text-secondary">
          If the problem continues{" "}
          <button
            onClick={openSupportForm}
            className="text-blue-600 underline hover:text-blue-800"
          >
            contact our support team
          </button>
        </p>
      </div>
    </div>
  );
}
